interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  return (
    <div className="error-message" role="alert">
      <p>{message}</p>
      {onRetry && (
        <button className="cta-button" onClick={onRetry} style={{ marginTop: '1rem' }}>
          Retry
        </button>
      )}
    </div>
  );
}
